import { initializeApp } from 'firebase/app';
import {
  initializeAuth,
  browserLocalPersistence,
  browserSessionPersistence,
  indexedDBLocalPersistence,
  inMemoryPersistence,
} from 'firebase/auth';
import { getFirestore, connectFirestoreEmulator } from 'firebase/firestore';
import { getStorage, connectStorageEmulator } from 'firebase/storage';
import { getFunctions, connectFunctionsEmulator } from 'firebase/functions';

const storageBucket = process.env.REACT_APP_FIREBASE_STORAGE_BUCKET || 'gs://tattoo-shop-assistant';

// ✅ Firebase Config
const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY || "AIzaSyBJColti1ir_sZcsRlRDPNoyRzHu_ZhmGs",
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN || "tattoo-shop-assistant.firebaseapp.com",
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID || "tattoo-shop-assistant",
  storageBucket,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID || "723629929070",
  appId: process.env.REACT_APP_FIREBASE_APP_ID || "1:723629929070:web:3bb14741c47ed15e592c7f",
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID || "G-QF79J0PZ0Q"
};

export const firebaseProjectId = firebaseConfig.projectId;


// ✅ Initialize App
const app = initializeApp(firebaseConfig);

// ✅ Initialize Auth with Safari/iOS-friendly persistence
const auth = initializeAuth(app, {
  persistence: [
    indexedDBLocalPersistence,
    browserLocalPersistence,
    browserSessionPersistence,
    inMemoryPersistence,
  ],
});

// ✅ Export Firebase services
export { app, auth };
export const db = getFirestore(app);
export const storage = getStorage(app, storageBucket);
export const functions = getFunctions(app, 'us-central1');

const isLocalhost =
  typeof window !== 'undefined' &&
  (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1');

const useEmulators =
  isLocalhost &&
  process.env.REACT_APP_USE_EMULATORS === 'true';

if (useEmulators) {
  try {
    connectFirestoreEmulator(db, 'localhost', 8080);
  } catch {
    // Ignore "already connected" during HMR reloads.
  }

  try {
    connectStorageEmulator(storage, 'localhost', 9199);
  } catch {
    // Ignore "already connected" during HMR reloads.
  }

  try {
    connectFunctionsEmulator(functions, 'localhost', 5001);
  } catch {
    // Ignore "already connected" during HMR reloads.
  }
}
